import React from "react";
import { Instagram } from "lucide-react";
import { SectionHeading } from "@/components/common/SectionHeading";
import { useImagery } from "@/hooks/useCatalog";
import { instagramHandle, social } from "@/config/brand";

const INSTAGRAM_URL = social.find((s) => s.icon === "instagram")?.href;

export function InstagramSection() {
  const { data } = useImagery();
  const gallery = data?.instagram || [];

  return (
    <section className="py-16 lg:py-24" data-testid="instagram-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading eyebrow={instagramHandle} title="Follow us for everyday sparkle" />
        <div className="mt-12 grid grid-cols-2 gap-2 sm:gap-3 md:grid-cols-4">
          {gallery.map((img) => (
            <a
              key={img}
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative aspect-square overflow-hidden bg-cream"
            >
              <img src={img} alt="ÉLORA on Instagram" loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <span className="absolute inset-0 grid place-items-center bg-ink/40 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                <Instagram className="text-ivory" size={24} />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
